import { render, staticRenderFns } from "./StashDetails.vue?vue&type=template&id=70eb3de3&"
import script from "./StashDetails.vue?vue&type=script&lang=js&"
export * from "./StashDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports